module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/73/assets/images/d7d4c9356712c86cff65deb5dd3dbb71.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/filter_default.svg
// module id = j7uT
// module chunks = 0